/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CustomFieldDefinition } from './CustomFieldDefinition';
import {
  CustomFieldDefinitionFromJSON,
  CustomFieldDefinitionFromJSONTyped,
  CustomFieldDefinitionToJSON,
} from './CustomFieldDefinition';

/**
 * Unified read serializer for custom field values across both target models.
 * @export
 * @interface CustomFieldValueRead
 */
export interface CustomFieldValueRead {
  /**
   *
   * @type {number}
   * @memberof CustomFieldValueRead
   */
  readonly customFieldValueId: number;
  /**
   *
   * @type {CustomFieldDefinition}
   * @memberof CustomFieldValueRead
   */
  readonly definition: CustomFieldDefinition;
  /**
   *
   * @type {string}
   * @memberof CustomFieldValueRead
   */
  readonly value: string;
}

/**
 * Check if a given object implements the CustomFieldValueRead interface.
 */
export function instanceOfCustomFieldValueRead(value: object): value is CustomFieldValueRead {
  if (!('customFieldValueId' in value) || value['customFieldValueId'] === undefined) return false;
  if (!('definition' in value) || value['definition'] === undefined) return false;
  if (!('value' in value) || value['value'] === undefined) return false;
  return true;
}

export function CustomFieldValueReadFromJSON(json: any): CustomFieldValueRead {
  return CustomFieldValueReadFromJSONTyped(json, false);
}

export function CustomFieldValueReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomFieldValueRead {
  if (json == null) {
    return json;
  }
  return {
    customFieldValueId: json['custom_field_value_id'],
    definition: CustomFieldDefinitionFromJSON(json['definition']),
    value: json['value'],
  };
}

export function CustomFieldValueReadToJSON(
  value?: Omit<CustomFieldValueRead, 'customFieldValueId' | 'definition' | 'value'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {};
}
